import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import { initCounters } from '../components/counter';

Alpine.plugin(collapse);

Alpine.data('referralFaq', () => ({
	data: window.referralFaqData || {},
	activeItem: null,

	init() {
		// No special initialization needed for simple FAQ
	},

	toggleItem(itemId) {
		const isOpening = this.activeItem !== itemId;
		this.activeItem = isOpening ? itemId : null;
	},
}));

Alpine.start();

document.addEventListener('DOMContentLoaded', () => {
	initCounters('.js-counter');

	document.querySelectorAll('.smooth-scroll-link').forEach((link) => {
		link.addEventListener('click', (e) => {
			e.preventDefault();
			const target = document.querySelector(link.getAttribute('href'));
			if (target) {
				const headerHeight =
					document.querySelector('.site-header')?.offsetHeight || 0;
				const targetPosition =
					target.getBoundingClientRect().top +
					window.pageYOffset -
					headerHeight;
				window.scrollTo({ top: targetPosition, behavior: 'smooth' });
			}
		});
	});
});
